import { render, staticRenderFns } from "./AdicionarProcedimento.vue?vue&type=template&id=30841d84&"
import script from "./AdicionarProcedimento.vue?vue&type=script&lang=js&"
export * from "./AdicionarProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports